import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-[10050] overflow-hidden"
}
const _hoisted_2 = { class: "relative flex h-full items-center justify-center p-4 pointer-events-none" }
const _hoisted_3 = { class: "flex-shrink-0 px-6 py-4 border-b border-gray-200" }
const _hoisted_4 = { class: "text-lg font-semibold text-black" }
const _hoisted_5 = { class: "flex-1 min-h-0 overflow-y-auto overscroll-contain px-6 py-5" }
const _hoisted_6 = { class: "text-sm leading-relaxed mb-4 flex items-start gap-3" }
const _hoisted_7 = {
  key: 0,
  class: "fas fa-exclamation-triangle text-amber-500 text-xl mt-0.5 flex-shrink-0"
}
const _hoisted_8 = { class: "flex-1 min-w-0" }
const _hoisted_9 = {
  key: 0,
  class: "text-black whitespace-pre-line"
}
const _hoisted_10 = {
  key: 1,
  class: "text-black whitespace-pre-line"
}
const _hoisted_11 = {
  key: 2,
  class: "text-red-600 mt-3 whitespace-pre-line"
}
const _hoisted_12 = {
  key: 3,
  class: "text-black mt-3 whitespace-pre-line"
}
const _hoisted_13 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_14 = { class: "text-sm font-medium text-black mb-2" }
const _hoisted_15 = { class: "max-h-60 overflow-y-auto overscroll-contain border border-gray-200 rounded-md p-3 bg-gray-50" }
const _hoisted_16 = { class: "space-y-1" }
const _hoisted_17 = { class: "min-w-0 break-words" }
const _hoisted_18 = {
  key: 0,
  class: "shrink-0 text-gray-600 whitespace-nowrap"
}
const _hoisted_19 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_20 = {
  key: 2,
  class: "mt-4 flex items-start gap-3 rounded-md border border-blue-200 bg-blue-50 px-4 py-3 text-sm text-blue-800"
}
const _hoisted_21 = { class: "whitespace-pre-line" }
const _hoisted_22 = { class: "flex-shrink-0 px-6 py-4 bg-gray-50 rounded-b-lg flex justify-end space-x-3 border-t border-gray-200" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}

import { computed } from "vue";
import { useBodyScrollLock } from "@/composables/useBodyScrollLock";

interface ConfirmModalReference {
  label: string;
  meta?: string;
}

interface Props {
  show: boolean;
  title: string;
  message: string;
  attention?: string;
  reminder?: string;
  confirmText?: string;
  confirmButtonClass?: string;
  references?: Array<string | ConfirmModalReference>;
  confirmDisabled?: boolean;
  confirmLoading?: boolean;
  progressLabel?: string;
  loadingText?: string;
  showAttentionIcon?: boolean;
  lockBackgroundScroll?: boolean;
  maxWidthClass?: string;
}

interface Emits {
  (e: "confirm"): void;
  (e: "cancel"): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmModal',
  props: {
    show: { type: Boolean },
    title: {},
    message: {},
    attention: {},
    reminder: {},
    confirmText: { default: "Confirmer" },
    confirmButtonClass: { default: "bg-blue-600 hover:bg-blue-700 focus:ring-blue-500" },
    references: {},
    confirmDisabled: { type: Boolean, default: false },
    confirmLoading: { type: Boolean, default: false },
    progressLabel: { default: "" },
    loadingText: { default: "Traitement en cours…" },
    showAttentionIcon: { type: Boolean, default: false },
    lockBackgroundScroll: { type: Boolean, default: false },
    maxWidthClass: { default: "max-w-md" }
  },
  emits: ["confirm", "cancel"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const shouldLockBackgroundScroll = computed(
  () => props.show && props.lockBackgroundScroll,
);
useBodyScrollLock(shouldLockBackgroundScroll);

const handleConfirm = () => {
  if (props.confirmLoading) return;
  emit("confirm");
};

const handleCancel = () => {
  if (props.confirmLoading) return;
  emit("cancel");
};

const handleOverlayClick = () => {
  handleCancel();
};

function referenceLabel(ref: string | ConfirmModalReference): string {
  return typeof ref === "string" ? ref : ref.label;
}

function referenceMeta(ref: string | ConfirmModalReference): string {
  return typeof ref === "string" ? "" : ref.meta?.trim() || "";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      "enter-active-class": "transition-opacity duration-300",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "transition-opacity duration-300",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (_ctx.show)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", {
                class: "absolute inset-0 bg-black bg-opacity-50",
                onClick: handleOverlayClick
              }),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", {
                  class: _normalizeClass([
            'pointer-events-auto bg-white rounded-lg shadow-xl w-full max-h-[calc(100vh-2rem)] flex flex-col transform transition-all',
            _ctx.maxWidthClass,
          ])
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.title), 1)
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      (_ctx.showAttentionIcon)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_8, [
                        (_ctx.attention)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.attention), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.message), 1)),
                        (_ctx.reminder)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.reminder), 1))
                          : _createCommentVNode("", true),
                        (_ctx.attention && _ctx.message)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.message), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (_ctx.references && _ctx.references.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("p", _hoisted_14, " Produits concernés (" + _toDisplayString(_ctx.references.length) + "): ", 1),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("ul", _hoisted_16, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.references, (ref, index) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: index,
                                  class: "text-sm text-black flex items-start justify-between gap-3"
                                }, [
                                  _createElementVNode("span", _hoisted_17, " • " + _toDisplayString(referenceLabel(ref)), 1),
                                  (referenceMeta(ref))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(referenceMeta(ref)), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.$slots.extra)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _renderSlot(_ctx.$slots, "extra")
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.confirmLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fas fa-spinner fa-spin mt-0.5 shrink-0" }, null, -1)),
                          _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.progressLabel || "Traitement en cours, merci de patienter…"), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("button", {
                      type: "button",
                      disabled: _ctx.confirmLoading,
                      class: "px-4 py-2 text-sm font-medium text-black bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
                      onClick: handleCancel
                    }, " Annuler ", 8, _hoisted_23),
                    _createElementVNode("button", {
                      type: "button",
                      disabled: _ctx.confirmDisabled || _ctx.confirmLoading,
                      class: _normalizeClass([_ctx.confirmButtonClass, "inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-white rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"]),
                      onClick: handleConfirm
                    }, [
                      (_ctx.confirmLoading)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_25))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_ctx.confirmLoading ? _ctx.loadingText : _ctx.confirmText), 1)
                    ], 10, _hoisted_24)
                  ])
                ], 2)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})